package com.xtream.ui.ui.widget

import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsFocusedAsState
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.AssistChip
import androidx.compose.material3.AssistChipDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp

@Composable
fun XAssistChip(title:String?,
                modifier: Modifier=Modifier,
                vectorIcon: Painter?=null,
                borderEnabled:Boolean=true,
                tint: Color =   MaterialTheme.colorScheme.onBackground.copy(alpha = 0.9f),
                isSelected:Boolean=false,
                onClick: (() -> Unit)? = null

) {
    val interactionSource = remember { MutableInteractionSource() }

    val focusState = interactionSource.collectIsFocusedAsState()
    AssistChip(
        interactionSource = interactionSource,
        modifier = modifier

            .height(24.dp)
            .padding(horizontal = 4.dp),
        enabled = onClick!=null,

        colors = AssistChipDefaults.assistChipColors(
            disabledLabelColor = tint,
            disabledLeadingIconContentColor = tint,


            containerColor = if (isSelected && focusState.value) MaterialTheme.colorScheme.onBackground.copy(alpha = 0.8f) else if (isSelected || focusState.value) MaterialTheme.colorScheme.onBackground  else Color.Transparent,
            labelColor =  if(focusState.value) MaterialTheme.colorScheme.background else if (!isSelected) MaterialTheme.colorScheme.onBackground else MaterialTheme.colorScheme.background ,

        ),

        border = AssistChipDefaults.assistChipBorder(
            disabledBorderColor = MaterialTheme.colorScheme.onBackground.copy(alpha = if (borderEnabled) 0.5f else 0f),
            borderWidth = .1.dp,
            enabled = borderEnabled

        ),

        leadingIcon = {
            if (vectorIcon != null)
                Icon(painter = vectorIcon,
                    modifier = Modifier.size(14.dp),
                    contentDescription = title
                )
        },
        label = { Text(title ?: "",
            style = MaterialTheme.typography.bodySmall,
            fontWeight = FontWeight.Bold

        ) },
        onClick = { onClick?.invoke() }
    )
}